import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { legacyCasesService } from "../services/legacyCases.service";
import type { LegacyExistingCaseAttachmentRequest } from "../types/legacyCases";

export function useLegacyCaseCollision(id: string | undefined) {
  return useQuery({
    queryKey: ["legacy-case-collision", id],
    queryFn: () => legacyCasesService.collision(id!),
    enabled: Boolean(id),
    refetchOnWindowFocus: "always",
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
  });
}

export function useAttachLegacyDocumentToCase(archiveId: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (payload: LegacyExistingCaseAttachmentRequest) =>
      legacyCasesService.attachToExistingCase(archiveId, payload),
    onSuccess: (result) => {
      void client.invalidateQueries({
        queryKey: ["case-files", result.caseId],
      });
      void client.invalidateQueries({ queryKey: ["case", result.caseId] });
    },
    onError: () => {
      void client.invalidateQueries({
        queryKey: ["legacy-case-collision", archiveId],
      });
    },
  });
}
